import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f8a4e870 = () => interopDefault(import('../pages/news/_slug/index.vue' /* webpackChunkName: "pages/news/_slug/index" */))
const _2ac53822 = () => interopDefault(import('../pages/projects/_slug/index.vue' /* webpackChunkName: "pages/projects/_slug/index" */))
const _24a152eb = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _86739c34 = () => interopDefault(import('../pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))
const _2f08a8a1 = () => interopDefault(import('../pages/_slug/_slug/index.vue' /* webpackChunkName: "pages/_slug/_slug/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/news/:slug",
    component: _f8a4e870,
    name: "news-slug"
  }, {
    path: "/projects/:slug",
    component: _2ac53822,
    name: "projects-slug"
  }, {
    path: "/",
    component: _24a152eb,
    name: "index"
  }, {
    path: "/:slug",
    component: _86739c34,
    name: "slug"
  }, {
    path: "/:slug/:slug",
    component: _2f08a8a1,
    name: "slug-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
